<template>
  <div>
    <v-stepper v-model="step" class="rounded-0 claim-stepper" alt-labels flat>
      <!-- <v-stepper-header class="px-2 stepper-top accent">
        <v-stepper-step
          step="1"
          editable
          :complete="step > 1"
          class="px-0 step-header"
        >
          {{ $t("components.claim_submission.step1.title") }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="2"
          :editable="memberIdentity !== null && memberIdentity !== undefined"
          :complete="step > 2"
          class="px-0 step-header"
        >
          {{ $t("components.claim_submission.step2.title") }}
        </v-stepper-step>
      </v-stepper-header> -->

      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <search-members-form
            @select="
              loadMemberIdentity($event);
              step = 2;
            "
            @plan-name="
              $emit('plan-name', $event);
              planName = $event;
            "
            @plan-number="
              $emit('plan-number', $event);
              planNumber = $event;
            "
            @plan-start-date="planStartDate = $event"
            :coverageType="coverageType"
          />
        </v-stepper-content>

        <v-stepper-content step="2" class="pa-0">
          <claim-submission-tabs
            ref="cst"
            v-if="claimSubmission"
            :claimSubmission="claimSubmission"
            :memberIdentity="memberIdentity"
            :patients="patients"
            @reload-member-identity="reloadMemberIdentity"
            :planName="planName"
            :planNumber="planNumber"
            :submitted="false"
            :review="false"
            @close="$emit('close')"
            :planStartDate="planStartDate"
            @reload-claim-submission="loadClaimSubmission"
            :hasHSA="hasHSA"
            :planIdentityId="planIdentity.Id"
            :isNew="true"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <!-- Confirm delete expense dialog -->

    <!-- Confirm cancel claim dialog -->

    <!-- <popup-text-dialog
      :model="medicalClaimDialog"
      titleIcon="mdi-hospital-box-outline"
      :title="$t('components.claim_submission.medical_claims')"
      :html="
        $t('components.claim_submission.medical_claims_text_{0}', [
          medicalClaimEmail,
        ])
      "
      :width="800"
      @close="medicalClaimDialog = false"
    /> -->
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>

    <v-snackbar v-model="snackbar" color="success" :timeout="3000">
      {{ successMessage }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import NewClaim from "@/components/Claims/NewClaim.vue";
// import ClaimFormFooter from "@/components/Claims/ClaimFormFooter.vue";
// import ClaimSubmitPreview from "@/components/ClaimCentre/ClaimSubmitPreview.vue";
// import ExpensesTable from "@/components/Claims/ExpensesTable.vue";
// import ClaimSubmitConfirmation from "@/components/ClaimCentre/ClaimSubmitConfirmation.vue";
// import PopupTextDialog from "@/components/controls/PopupTextDialog.vue";
import ErrorHandler from "@/components/ErrorHandler.vue";
import SearchMembersForm from "@/components/Claims/SearchMembersForm.vue";
import ClaimSubmissionTabs from "@/components/Claims/ClaimSubmissionTabs.vue";
import { translate2 } from "@/trans2";
export default {
  components: {
    // NewClaim,
    // ClaimSubmitPreview,
    // ExpensesTable,
    ErrorHandler,
    // ClaimFormFooter,
    // ClaimSubmitConfirmation,
    // PopupTextDialog,
    SearchMembersForm,
    ClaimSubmissionTabs,
  },
  props: ["coverageType", "memberIdentityId"],
  data() {
    return {
      claimSubmission: null,
      submittedClaim: { Claims: [], Proofs: [] },
      error: undefined,
      snackbar: false,
      successMessage: "",
      saving: false,
      // selectedExpense: null,
      claimPreviewDialog: false,
      cancelClaimDialog: false,
      medicalClaimDialog: false,
      medicalClaimEmail: "myclaims@sunlife.com",
      claimSent: false,
      claimToDeleteIndex: null,
      submissionNumber: null,
      step: 1,
      // newExpense: {
      //   TotalExpense: null,
      //   TotalCob: null,
      //   HasCob: false,
      //   ExpenseReceipt: null,
      //   CobReceipt: null,
      //   Referral: null,
      // },
      memberIdentity: null,
      patients: [],
      planName: null,
      planNumber: null,
      planStartDate: null,
      hasHSA: false,
      planIdentity: null,
      loading: false,
    };
  },
  computed: {
    // ...mapGetters("common", ["userProfile", "portalPlanNumber"]),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
    }),
    ...mapGetters("common", { selectedPlan: "plan" }),
    // isInternationalStudent() {
    //   const memberGroup = this.userProfile?.MemberGroup?.Name;
    //   if (memberGroup) {
    //     if (memberGroup.toLowerCase().includes("international")) return true;
    //   }
    //   return false;
    // },
  },
  
  mounted() {
    console.log("mounted: ", this.memberIdentityId);
    if (this.memberIdentityId !== null && this.memberIdentityId !== undefined) {
      this.loadMemberDetails();
    }
  },
  
  methods: {
    ...mapActions("data", ["submitClaim"]),
    ...mapActions("plansMembers", ["getMemberInfo", "getPlan"]),
    ...mapActions("claims", [
      "getClaimSubmissionById",
      "getPlanBenefitById",
      "getProviderById",
      "getDrugByDIN",
      "getCoveredBenefitById",
    ]),
    // save() {
    //   this.$refs.cst && this.$refs.cst.save()
    // },
    isChanged() {
      // return (this.$refs.cst && this.$refs.cst.isChanged()) || (!this.$refs.cst && false);
      return this.step === 2;
    },
    async loadMemberDetails() {
      await this.loadPlanDetails(this.selectedPlan.Id);
      this.loading = true;
      try {
        let memberIdentity = (await this.getMemberInfo({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentityId,
          odataQuery:
            "$select=Id,Email,PlanIdentityId,PlanEntryDate,TerminatedAt&$expand=CurrentMembershipStatus($expand=MemberGroupIdentity($select=Id)),MemberIdentification($select=Certificate),CurrentBankAccount,CurrentMember($select=LastName,FirstName,MiddleName,DateOfBirth),CurrentDependants($select=Id,IdentityId,FirstName,MiddleName,LastName,DateOfBirth;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentContactInformation($expand=Address($expand=Country($expand=Translations),Province($expand=Translations)))",
        })).data;
        this.loadMemberIdentity(memberIdentity);
        this.step = 2;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async loadPlanDetails(planIdentityId) {
      this.loading = true;
      try {
        this.planIdentity = (await this.getPlan(planIdentityId)).data;
        this.$emit("plan-name", this.getPlanName(this.planIdentity));
        this.$emit("plan-number", this.getPlanNumber(this.planIdentity));
        this.$emit("plan-start-date", this.getPlanStartDate(this.planIdentity));
        this.planName = this.getPlanName(this.planIdentity);
        this.planNumber = this.getPlanNumber(this.planIdentity);
        this.planStartDate = this.getPlanStartDate(this.planIdentity);
        this.hasHSA = this.planIdentity.HasHSA;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    getPlanName(item) {
      return translate2(item.Current, "Name");
    },
    getPlanNumber(item) {
      return item && item.UniqueIdentifier;
    },
    getPlanStartDate(item) {
      // console.log(item);
      return item && item.FirstRenewalDate;
    },
    async reloadMemberIdentity() {
      try {
        this.memberIdentity = (await this.getMemberInfo({
          planIdentityId: this.memberIdentity.PlanIdentityId,
          memberIdentityId: this.memberIdentity.Id,
          odataQuery:
            "$select=Id,Email,PlanIdentityId,PlanEntryDate,TerminatedAt&$expand=CurrentMembershipStatus($expand=MemberGroupIdentity($select=Id)),MemberIdentification($select=Certificate),CurrentBankAccount,CurrentMember($select=LastName,FirstName,MiddleName,DateOfBirth),CurrentDependants($select=IdentityId,Id,FirstName,MiddleName,LastName,DateOfBirth;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentContactInformation($expand=Address($expand=Country($expand=Translations),Province($expand=Translations)))",
        })).data;
        // console.log(this.memberIdentity);
        this.getPatients();
      } catch (error) {
        this.error = error;
      }
    },
    async loadMemberIdentity(v) {
      console.log(v);
      this.memberIdentity = v;
      if (v) {
        await this.loadPlanDetails(this.memberIdentity.PlanIdentityId);
        this.getPatients();
        this.claimSubmission = {
          CoverageType: this.coverageType,
          Claims: [
            {
              Identifier: Math.random().toString(),
            },
          ],
          Proofs: [],
          Timestamp: new Date().toUTCString(),
          Creator: this.user,
          UserType: "Admin",
          Payee:
            this.coverageType === "Dental" || this.coverageType === "Health" || this.coverageType === "HSA"
              ? undefined
              : "Member",
        };
        if (this.coverageType==="SickDay") {
          this.claimSubmission.Claims[0].Patient = this.patients[0];
        } else if (this.patients.length === 1) {
          if (this.coverageType === "Dental") {
            this.claimSubmission.Patient = this.patients[0];
          } else {
            this.claimSubmission.Claims[0].Patient = this.patients[0];
          }
        }
        
        // console.log("new claim submission", this.claimSubmission);
      } else {
        this.claimSubmission = null;
      }
    },
    getPatients() {
      this.patients = this.memberIdentity.CurrentDependants.sort((a, b) => {
        if (Date.parse(a.DateOfBirth) < Date.parse(b.DateOfBirth)) {
          return -1;
        } else if (Date.parse(a.DateOfBirth) === Date.parse(b.DateOfBirth)) {
          return 0;
        } else {
          return 1;
        }
      });
      this.patients.unshift({
        Id: this.memberIdentity.Id,
        FirstName: this.memberIdentity.CurrentMember.FirstName,
        LastName: this.memberIdentity.CurrentMember.LastName,
        MiddleName: this.memberIdentity.CurrentMember.MiddleName,
        DateOfBirth: this.memberIdentity.CurrentMember.DateOfBirth,
      });
    },

    toDecimal(str) {
      var n = Number.parseFloat(str);
      if (!str || isNaN(n) || n < 0) return 0;
      return this.decimalTwo(n);
    },
    decimalTwo(value, exp = -2) {
      exp = Number(exp);
      value = Number(value);
      if (exp % 1 !== 0 || Number.isNaN(value)) {
        return NaN;
      } else if (exp === 0) {
        return Math.round(value);
      }
      const [magnitude, exponent = 0] = value.toString().split("e");
      const adjustedValue = Math.round(`${magnitude}e${exponent - exp}`);
      // Shift back
      const [newMagnitude, newExponent = 0] = adjustedValue
        .toString()
        .split("e");
      return Number(`${newMagnitude}e${+newExponent + exp}`);
    },
    async loadClaimSubmission(claimSubmissionId) {
      console.log("load claim submission", claimSubmissionId);
      this.loading = true;
      try {
        let item = (await this.getClaimSubmissionById({
          id: claimSubmissionId,
        })).data;
        for (let claim of item.Claims) {
          claim.Identifier = Math.random().toString();
          if (claim.DependantId) {
            claim.Patient = this.patients.filter(
              (o) => o.IdentityId === claim.DependantId
            )[0];
          } else {
            claim.Patient = this.patients.filter(
              (o) => o.Id === claim.MemberId
            )[0];
          }
          claim.PlanBenefit = (await this.getPlanBenefitById({
            id: claim.PlanBenefitId,
          })).data.value[0];
console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$", claim.PlanBenefit);
          if (
            claim.HSACoveredBenefitId !== null &&
            claim.HSACoveredBenefitId !== undefined &&
            claim.HSACoveredBenefitId !== "00000000-0000-0000-0000-000000000000"
          ) {
            claim.CoveredBenefit = (await this.getCoveredBenefitById({
              planIdentityId: claim.PlanId,
              id: claim.HSACoveredBenefitId,
            })).data.value.filter((o) => o.Id === claim.HSACoveredBenefitId)[0];
          }
          console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ covered: ", claim.CoveredBenefit);
          // console.log(JSON.stringify(claim));
          // let num = parseFloat(claim.ExpenseAmount);
          // console.log(num);
          // if (!isNaN(num)) {
          //   console.log(num.toFixed(2))
          //   claim.ExpenseAmount = num.toFixed(2);
          // } else {
          //   claim.ExpenseAmount = "0.00";
          // }
          // num = parseFloat(claim.COBAmount);
          // if (!isNaN(num)) {
          //   claim.COBAmount = num.toFixed(2);
          // } else {
          //   claim.ExpenseAmount = "0.00";
          // }
          // num = parseFloat(claim.LabFee);
          // if (!isNaN(num)) {
          //   claim.LabFee = num.toFixed(2);
          // } else {
          //   claim.ExpenseAmount = "0.00";
          // }
          if (claim.ToothCodeId !== null && claim.ToothCodeId !== undefined) {
            // console.log("claim has tooth code id: ", claim.ToothCodeId);
            claim.ToothCode = this.columnsDropDownOptions.Models.ToothCode.filter(
              (o) => o.Id === claim.ToothCodeId
            )[0];
            // console.log(claim.ToothCode);
            // console.log(this.columnsDropDownOptions.Models.ToothCode);
          }
          if (claim.DIN !== null && claim.DIN !== undefined) {
            claim.DIN = (await this.getDrugByDIN({
              planIdentityId: claim.PlanId,
              din: claim.DIN,
            })).data.value[0];
          }
        }
        for (let proof of item.Proofs) {
          proof.Identifier = Math.random().toString();
        }
        for (let note of item.Notes) {
          note.Identifier = Math.random().toString();
        }
        item.Notes.unshift({
          Identifier: Math.random().toString(),
          Writer: this.user,
        });
        if (item.ProviderId && item.ProviderId !== "00000000-0000-0000-0000-000000000000") {
          item.Provider = (await this.getProviderById({
            id: item.ProviderId,
          })).data.value[0];
        }
        if (item.OfficeId && item.OfficeId !== "00000000-0000-0000-0000-000000000000") {
          item.Office = item.Provider.ProviderOffices.filter(
            (o) => o.OfficeId === item.OfficeId
          )[0];
        }
        item.Patient = item.Claims[0].Patient;
        item.Id = claimSubmissionId;
        this.claimSubmission = item;
        // console.log(JSON.stringify(item));
      } catch (error) {
        // console.log(error);
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-btn--outlined {
  border: thick solid;
}
.claim-btn {
  font-weight: 600 !important;
}
.claim >>> .v-btn__content {
  max-width: 180px;
  white-space: normal !important;
}
.preview-dialog >>> .v-dialog {
  margin: 0 24px !important;
}
.v-stepper__header {
  box-shadow: none;
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 100px;
}
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px -35px 0;
}
.step-header >>> .v-stepper__label {
  display: block !important;
  text-align: center;
  color: white !important;
}
.step-header >>> .v-stepper__label {
  display: block !important;
  text-align: center;
  color: white !important;
  font-size: 16px;
}
.double-border >>> .v-btn__content {
  background-color: var(--accent);
  border-radius: 10px;
  padding: 1em 1em;
  position: relative;
  margin: 0 auto;
  width: 160px;
  white-space: break-spaces;
}
.double-border >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
.double-border.v-btn--disabled >>> .v-btn__content {
  font-weight: bold;
  background-color: #d5d4d4;
  color: white;
  border-radius: 10px;
  padding: 1em 1em;
  position: relative;
  margin: 0 auto;
}
.double-border.v-btn--disabled >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
@media screen and (max-width: 460px) {
  .step-header >>> .v-stepper__label {
    font-size: 12px;
  }
}
.step-header >>> .v-stepper__step__step.primary {
  background-color: white !important;
  color: var(--accent);
  font-weight: 600;
}
.step-header >>> .v-stepper__step__step.primary i {
  color: var(--accent);
  font-weight: 600;
}
.claim-stepper >>> hr {
  border-top: 1px solid white !important;
  margin: 23px -30px 0 !important;
}
.step-header {
  padding: 12px 12px;
}
@media screen and (min-width: 1500px) {
  .stepper-top {
    padding: 0px 300px !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1499px) {
  .stepper-top {
    padding: 0px 200px !important;
  }
}
@media screen and (max-width: 999px) {
  .stepper-top {
    padding: 0px 20px !important;
  }
}
.double-border >>> .v-btn__content {
  background-color: var(--accent);
  border-radius: 10px;
  padding: 1em 1.5em;
  position: relative;
  margin: 0 auto;
}
.double-border >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
.double-border.v-btn--disabled >>> .v-btn__content {
  font-weight: bold;
  background-color: #d5d4d4;
  color: white;
  border-radius: 10px;
  padding: 1em 1.5em;
  position: relative;
  margin: 0 auto;
}
.double-border.v-btn--disabled >>> .v-btn__content:before {
  background: none;
  border: 3px solid rgb(255, 255, 255);
  border-radius: 10px;
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  pointer-events: none;
}
.double-border.v-btn--loading {
  font-weight: bold;
  background-color: #d5d4d4;
  color: white;
  border-radius: 10px;
  padding: 1em 1.5em;
  position: relative;
  margin: 0 auto;
}
.double-border >>> .v-btn__loader {
  color: var(--accent);
}
.apply-text {
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
}
.v-tooltip__content {
  max-width: 120px !important;
}
.apply-text {
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1.2;
}
</style>
